<template>
    <v-dialog max-width="700" v-model="$store.getters.distPointInfoDialog" @click:outside="closeDialog">

        <v-card class="elevation-6">
            <v-card-title class="primary">
                <span class="headline white--text">Στοιχεία σημείου διανομής</span>
                <v-spacer></v-spacer>
                <v-icon @click="closeDialog" color="white">close</v-icon>
            </v-card-title>
            <v-card-text>

                <v-row>
                    <v-col>
                        <v-list-item v-for="(info, n) in distPointInfo" :key="info.id">
                            <v-list-item-content>
                                <v-list-item-subtitle>{{info.label}} </v-list-item-subtitle>
                                <v-list-item-title v-if="info.id == 7 && info.value != null" @click="goToMap(info.value)">
                                    <a>Πατήστε Εδώ</a>
                                </v-list-item-title>
                                <v-list-item-title v-else>{{info.value}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

    import {eventBus} from "../../main";

    export default {
        name: "DistributionPointInfoDialog",
        props:{
            distPoint: Object
        },
        data: () => ({
            distPointInfo: [
                {label:'Κωδικός Ευδόξου' , id: 0, value: ''},
                {label:'Τίτλος' , id: 1, value: ''},
                {label:'Διεύθυνση' , id: 2, value: ''},
                {label:'Δήμος' , id: 3, value: ''},
                {label:'Νομός' , id: 4, value: ''},
                {label:'Τηλέφωνο' , id: 5, value: ''},
                {label:'Email' , id: 6, value: ''},
                {label:'Τοποθεσία στον χάρτη' , id: 7, value: null},
                {label:'Ώρες λειτουργίας' , id: 8, value: ''}
            ],
        }),

        methods: {
            closeDialog(){
                this.$store.commit('setDistPointInfoDialog', false);
            },

            //create the distPoint object o click event
            createDistPointObject() {
                this.distPointInfo[0].value = this.distPoint.id;
                this.distPointInfo[1].value = this.distPoint.distributionPointName;
                this.distPointInfo[2].value = this.distPoint.distributionPointAddress;
                this.distPointInfo[3].value = this.distPoint.cityName;
                this.distPointInfo[4].value = this.distPoint.prefectureName;
                this.distPointInfo[5].value = this.distPoint.distributionPointPhone
                this.distPointInfo[6].value = this.distPoint.distributionPointEmail;
                this.distPointInfo[7].value = this.distPoint.distributionPointLocationURL;
                this.distPointInfo[8].value = this.distPoint.distributionPointOpeningHours;
            },

            //open map in new tab
            goToMap(url) {

                window.open(url, '_blank');
            },
        },

        mounted() {
            this.createDistPointObject();
        }
    }
</script>

<style scoped>

</style>